/**
 * Equipment that leaves a package goes back into equipment_display_order.
 *
 * A job loaded for editing has no order entries for packaged equipment - the
 * package stands in for them - so removing the package, or taking an item out
 * of it, has to add those entries back or the items vanish from the list until
 * the job is saved and reopened. They go where the package sits, which is
 * where they were before they were packaged.
 *
 * Items that already have an entry (a package made in this session keeps its
 * items' entries, hidden while packaged) keep the place they have.
 */
export function restorePackagedEquipment(displayOrder, equipment, inventoryIds, packageId) {
  const restored = inventoryIds
    .map(inventoryId => (equipment || []).find(e => e.inventory_id === inventoryId))
    .filter(item => item && !displayOrder.some(o => o.type === 'equipment' && o.id === item.id))
    .map(item => ({ type: 'equipment', id: item.id }));

  if (restored.length === 0) return displayOrder;

  const packageIndex = displayOrder.findIndex(o => o.type === 'package' && o.id === packageId);
  const at = packageIndex === -1 ? displayOrder.length : packageIndex + 1;
  return [...displayOrder.slice(0, at), ...restored, ...displayOrder.slice(at)];
}
